import { render, staticRenderFns } from "./PublicHearingPublic.vue?vue&type=template&id=534c7b02&scoped=true&"
import script from "./PublicHearingPublic.vue?vue&type=script&lang=js&"
export * from "./PublicHearingPublic.vue?vue&type=script&lang=js&"
import style0 from "./PublicHearingPublic.vue?vue&type=style&index=0&id=534c7b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c7b02",
  null
  
)

export default component.exports